import { AfpantInboxFile } from "@/components/AfpantInboxFile/AfpantInboxFile";
import { DocumentTitle } from "@/components/DocumentTitle/DocumentTitle";
import { routeLoaderApiClient } from "@/lib/api";
import { createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute("/_authenticated-user/superuser/afpant/$orgNumber/innboksfil/$inboxFileId/")({
  loader: async ({ params }) => {
    const { orgNumber, inboxFileId } = params;

    const res = await routeLoaderApiClient.superuser.afpant[":orgNumber"]["inbox-file"][":inboxFileId"].$get({
      param: {
        orgNumber,
        inboxFileId,
      },
    });

    if (res.ok === false) {
      throw new Error("Failed to fetch inbox file");
    }

    return {
      file: await res.json(),
    };
  },
  head: () => ({
    meta: [{ title: "Innboksfil | Alice & Bob" }],
  }),
  component: Page,
});

function Page() {
  const { orgNumber } = Route.useParams();
  const { file } = Route.useLoaderData();

  return (
    <>
      <DocumentTitle>Innboksfil</DocumentTitle>

      <AfpantInboxFile orgNumber={orgNumber} file={file} />
    </>
  );
}
